import { lastInstanceIdStore, useOrganizations } from '@meteor/state';
import { useLayoutEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Paths } from '../paths';

export let IndexRedirect = () => {
  let orgs = useOrganizations();
  let navigate = useNavigate();
  let [params] = useSearchParams();
  let organizationId = params.get('organization_id');

  let navigatedRef = useRef(false);
  useLayoutEffect(() => {
    if (!orgs.data) return;

    if (organizationId) {
      let org = orgs.data.find(o => o.id === organizationId || o.slug === organizationId);
      let defaultInstance = org?.projects.flatMap(p => p.instances)[0];

      if (defaultInstance) {
        navigate(Paths.instance(defaultInstance), { replace: true });
        return;
      }
    }

    lastInstanceIdStore.get().then(lastInstanceId => {
      if (navigatedRef.current) return;

      let org = orgs.data!.find(org =>
        org.projects.some(p => p.instances.some(i => i.id === lastInstanceId))
      );
      let instance = org?.projects
        .flatMap(p => p.instances)
        .find(i => i.id === lastInstanceId);

      let defaultInstance = orgs.data?.flatMap(o => o.projects.flatMap(p => p.instances))[0];

      if (instance) {
        navigate(Paths.instance(instance), { replace: true });
      } else if (defaultInstance) {
        navigate(Paths.instance(defaultInstance), { replace: true });
      } else {
        navigate(Paths.welcome(), { replace: true });
      }

      navigatedRef.current = true;
    });
  }, [orgs.data]);

  return null;
};
